import getCompanyFinancialInfoModuleStatus from '../../../CompanyFinancialInfo/lib/getModuleStatus';
import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import { GetVerificationStep, VerificationStepCategory } from './types';

const getCompanyFinancialInfoStep: GetVerificationStep = ({
  verificationData,
}) => {
  const {
    shouldAskSanctionsDeclarationQuestions,
    viewer: { company },
  } = verificationData;

  const status = getCompanyFinancialInfoModuleStatus({
    companyProfile: company.profile,
    shouldAskSanctionsDeclarationQuestions,
  });

  return {
    errors: [],
    id: State.COMPANY_FINANCIAL_INFO,
    metadata: {
      category: VerificationStepCategory.CompanyInfo,
      event: model.events.GO_COMPANY_FINANCIAL_INFO(),
      iconName: 'building',
      label: locales.companyFinancialInfo,
    },
    status,
  };
};

export default getCompanyFinancialInfoStep;
